import { service } from 'services';
import { hotGetAction } from 'utils';
import { getDispatch } from 'redux/store';
import { ACTIONS_TYPES } from '../helper';

export default {
  setLayoutTitle: async ({ layout = {} }) => {
    const dispatch = getDispatch();

    return dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: {
        layout,
      },
    });
  },

  quickUpdate: (data) => {
    const dispatch = getDispatch();

    return dispatch({
      type: ACTIONS_TYPES.COMMON.QUICK_UPDATE,
      payload: { ...data },
    });
  },

  updateLayoutScreen: ({ screen }) => {
    const dispatch = getDispatch();

    return dispatch({
      type: ACTIONS_TYPES.COMMON.RESIZE_SCREEN,
      payload: { screen },
    });
  },

  getFeatures: async () => hotGetAction({
    action: ACTIONS_TYPES.COMMON.GET_FEATURES,
    apiResult: service.common.getFeatures(),
  }),
};
